import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/bootstrap': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M292.3 311.9c0 42.4-39.7 41.4-43.9 41.4h-80.9v-81.7h80.9c42.6 0 43.9 31.9 43.9 40.3zM242.2 238.8h-74.7v-72.2h74.7c34.9 0 38.4 20.3 38.4 35.9 0 37.3-37.8 36.3-38.4 36.3zM448 106.7v298.7c-0.1 41.1-33.6 74.5-74.7 74.7h-298.7c-41.1-0.1-74.5-33.6-74.7-74.7v-298.7c0.1-41.1 33.6-74.5 74.7-74.7h298.7c41.1 0.1 74.5 33.6 74.7 74.7zM338.1 317.9c0-21.6-6.6-58.3-49-67.4v-0.7c22.9-9.8 37.3-28.3 37.3-55.6 0-7 2-64.8-77.6-64.8h-127v261.3c128.2 0 139.9 1.7 163.6-5.7 14.2-4.4 52.7-18 52.7-67.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/bootstrap.js
// module id = 734
// module chunks = 0